import React, { useEffect, useState } from 'react';
import { ColorPicker } from 'primereact/colorpicker';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { fetchCroppedImage } from '@/utils/constants';
import { postData } from '@/services/api.service';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { toast } from 'react-toastify';
import {
  heroimg,
  priorityicon1,
  priorityicon2,
  priorityicon3,
  trustimg2,
} from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
const IntroEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>();
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabOne, setActiveTabOne] = useState(0);


  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [bannerImages, setBannerImages] = useState<string[]>([]);
  const [icons, setIcons] = useState<string[]>([]);

  // ...existing code...
const handleChange = (e: any, index?: number) => {
  const { value, name } = e.target;

  // For card_section_two fields
  if (typeof index === 'number' && name.startsWith('card.card_')) {
    const field = name.replace('card.', '');
    setEditData((prevJsonData: any) => {
      const updatedCards = [...prevJsonData.theme_2.home.section_2.card_section_two];
      updatedCards[index] = {
        ...updatedCards[index],
        [field]: value,
      };
      return {
        ...prevJsonData,
        theme_2: {
          ...prevJsonData.theme_2,
          home: {
            ...prevJsonData.theme_2.home,
            section_2: {
              ...prevJsonData.theme_2.home.section_2,
              card_section_two: updatedCards,
            },
          },
        },
      };
    });
    return;
  }

  // For card_section_one fields
  if (typeof index === 'number' && name.startsWith('card.') && activeTabOne === index) {
    const field = name.split('.')[1];
    setEditData((prevJsonData: any) => {
      const updatedCards = [...prevJsonData.theme_2.home.section_2.card_section_one];
      updatedCards[index] = {
        ...updatedCards[index],
        [field]: value,
      };
      return {
        ...prevJsonData,
        theme_2: {
          ...prevJsonData.theme_2,
          home: {
            ...prevJsonData.theme_2.home,
            section_2: {
              ...prevJsonData.theme_2.home.section_2,
              card_section_one: updatedCards,
            },
          },
        },
      };
    });
    return;
  }

  // Default handler for other fields
  setEditData((prevJsonData: any) => ({
    ...prevJsonData,
    theme_2: {
      ...prevJsonData?.theme_2,
      home: {
        ...prevJsonData?.theme_2.home,
        section_2: {
          ...prevJsonData?.theme_2?.home.section_2,
          [name]: value,
        },
      },
    },
  }));
};
// ...existing code...

  const addCollectionOne = () => {
    let updatedCollection: any = [
      ...editData.theme_2.home.section_2.card_section_one,
    ];

    let newCard = {
      icons: priorityicon1,
      title: '',
      count: '',
    };
    updatedCollection.splice(activeTabOne + 1, 0, newCard);
    setActiveTabOne(activeTabOne + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_2: {
            ...prevJsonData.theme_2.home.section_2,
            card_section_one: updatedCollection,
          },
        },
      },
    }));
  };

  const removeCollectionOne = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_2.home.section_2.card_section_one,
    ];
    updatedCollection.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_2: {
            ...prevJsonData.theme_2.home.section_2,
            card_section_one: updatedCollection,
          },
        },
      },
    }));
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_2.home.section_2.card_section_two,
    ];

    let newCard = {
      icons: priorityicon1,
      title: '',
      count: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_2: {
            ...prevJsonData.theme_2.home.section_2,
            card_section_two: updatedCollection,
          },
        },
      },
    }));
  };

  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_2.home.section_2.card_section_two,
    ];
    updatedCollection.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_2: {
            ...prevJsonData.theme_2.home.section_2,
            card_section_two: updatedCollection,
          },
        },
      },
    }));
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150")
    // setCropImageWidth("150")
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleBannerImageChange(imageLink);
    }
  };

  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_2.home.section_2.card_section_two,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      card_icon: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_2: {
            ...prevJsonData.theme_2.home.section_2,
            ...prevJsonData.theme_2.home.section_2.card_section_two,
            card_section_two: updatedCollection,
          },
        },
      },
    }));
  };

  const handleBannerImageChange = (image: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_2: {
            ...prevJsonData.theme_2.home.section_2,
            banner: image,
          },
        },
      },
    }));
  };

  // Auto-generate prompt based on intro section context
  const generateAutoPrompt = (): string => {
    // Get context from the current intro section data (theme_2)
    const title = editData?.theme_2?.home?.section_2?.title || '';
    const subHeading = editData?.theme_2?.home?.section_2?.sub_heading_top || '';
    const paragraph = editData?.theme_2?.home?.section_2?.mainparagraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional image for website intro section';
    
    if (title || subHeading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        // Extract keywords from paragraph
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add intro-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for introduction section, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the banner image
    handleBannerImageChange(imageUrl);
    
    // Add to banner images array for slider
    setBannerImages(prevImages => [...prevImages, imageUrl]);
  };

  // Auto-generate prompt based on current card context for icon
  const generateAutoPromptIcon = (): string => {
    // Get context from the current active card
    const currentCard = editData?.theme_2?.home?.section_2?.card_section_two?.[activeTab];
    const cardTitle = currentCard?.card_title || '';
    const cardSubHeading = currentCard?.card_sub_heading_top || '';
    const cardParagraph = currentCard?.card_paragraph || '';
    
    // Build context-based prompt for icon
    let contextPrompt = 'modern minimalist icon design';
    
    if (cardTitle || cardSubHeading || cardParagraph) {
      const contextParts: string[] = [];
      if (cardParagraph) {
        // Extract keywords from paragraph
        const keywords = cardParagraph.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add icon-specific styling
    contextPrompt += ', clean modern minimalist icon, professional design, suitable for card icon, vibrant colors, high quality, simple and recognizable, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    // Auto-apply the icon to the current active card
    handleImageChange(iconUrl, activeTab);
    
    // Add to icons array for slider
    setIcons(prevIcons => [...prevIcons, iconUrl]);
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load banner images from Redux
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template2';
      const currentTemplate = templateImages[templateKey];
      const imageArray = currentTemplate?.image || [];
      
      if (Array.isArray(imageArray) && imageArray.length > 0) {
        const imageUrls = imageArray.map((img: any) => img.url);
        setBannerImages(imageUrls);
      } else {
        setBannerImages([]);
      }
    } else {
      setBannerImages([]);
    }
  }, [templateImages, template]);

  // Load icon images from Redux
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template2';
      const currentTemplate = templateImages[templateKey];
      const iconArray = currentTemplate?.icon || [];
      
      if (Array.isArray(iconArray) && iconArray.length > 0) {
        const iconUrls = iconArray.map((img: any) => img.url);
        setIcons(iconUrls);
      } else {
        setIcons([]);
      }
    } else {
      setIcons([]);
    }
  }, [templateImages, template]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Two Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editData?.theme_2?.home?.section_2?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Sub Heading Top</label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_heading_top"
                      value={
                        editData?.theme_2?.home?.section_2?.sub_heading_top
                      }
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Paragraph
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleChange({
                            target: {
                              name: 'mainparagraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="about_us"
                        placeholder="Describe what you want in your paragraph. Example: 'Write about our company introduction and services'"
                        context="This is for an intro section description"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="mainparagraph"
                      value={editData?.theme_2?.home?.section_2?.mainparagraph}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Upload Image</label>
                    <input
                      type="file"
                      accept="image/png, image/jpeg"
                      className="form-control"
                      name="image"
                      onChange={updateImageSectionOne}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_1?.home?.section_4?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_1?.home?.section_4?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 2 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_1?.home?.section_4?.h3color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_1?.home?.section_4?.h3color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_1?.home?.section_4?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_1?.home?.section_4?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <AIImageGenerator
                generateAutoPrompt={generateAutoPrompt}
                onSave={handleAIImageSave}
                imageType="image"
                defaultWidth="1024"
                defaultHeight="1024"
                title="AI Image"
                autoGenerate={true}
                template={template}
              />

              <div className="row">
                <div className="col">
                  <div className="mb-3">

                    <div className="row">
                      <div className="col-md-12">
                        <div className="img-bg active">
                          <img
                            src={editData?.theme_2?.home?.section_2?.banner}
                            alt="Hero Image"
                          />
                        </div>
                        <div className="img-options">
                          <div className="row">
                            <div className="col-md-12">
                              {bannerImages.length > 0 ? (
                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: {
                                      slidesPerView: 1,
                                    },
                                    768: {
                                      slidesPerView: 4,
                                    },
                                    1024: {
                                      slidesPerView: 6,
                                    },
                                  }}
                                  className="homejson-slider"
                                >
                                  {bannerImages.map((images: string, index: any) => {
                                    return (
                                      <SwiperSlide key={index}>
                                        <div className="img-option">
                                          <img
                                            src={images}
                                            alt="Hero Image"
                                            className="img-fluid"
                                            onClick={() =>
                                              handleBannerImageChange(images)
                                            }
                                          />
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })}
                                </Swiper>
                              ) : (
                                <div className="empty-slider-state text-center py-4">
                                  <div className="empty-state-content">
                                    <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                    <h6 className="text-muted mb-2">No Images Available</h6>
                                    <p className="text-muted small mb-3">
                                      Generate AI images or upload your own to see them here
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        name="image"
                        onChange={updateImageSectionOne}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <h5 className="modal-title">Card Section One</h5>
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_2?.home?.section_2?.card_section_one.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option-wrapper">
                          <a
                            className={`nav-link ${
                              activeTabOne === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTabOne(index)}
                          >
                            Card {index + 1}
                          </a>
                          <a
                            className="nav-option-close"
                            onClick={() => {
                              removeCollectionOne(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_2?.home?.section_2?.card_section_one.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTabOne === index ? 'show active' : ''
                      }`}
                    >
                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="card.text"
                          value={card.text}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Count<small>(max 10 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="card.count"
                          value={card.count}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={10}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="add-section">
                <div className="row">
                  <div
                    onClick={() => {
                      addCollectionOne();
                    }}
                    className="col text-center"
                  >
                    Add Card<i className="fas fa-plus-square ms-2"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <h5 className="modal-title">Card Section Two</h5>
              <div className="col">
                <div className="mb-3">
                  <label className="form-label">
                    Title<small>(max 250 char)</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="card_section_title"
                    value={
                      editData?.theme_2?.home?.section_2?.card_section_title
                    }
                    onChange={handleChange}
                    maxLength={250}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Rating</label>
                  <input
                    type="text"
                    className="form-control"
                    name="rating"
                    value={editData?.theme_2?.home?.section_2?.rating}
                    onChange={handleChange}
                    maxLength={250}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Sub Heading</label>
                  <input
                    type="text"
                    className="form-control"
                    name="card_sub_text"
                    value={editData?.theme_2?.home?.section_2?.card_sub_text}
                    onChange={handleChange}
                    maxLength={250}
                  />
                </div>
              </div>
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_2?.home?.section_2?.card_section_two.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option-wrapper">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card {index + 1}
                          </a>
                          <a
                            className="nav-option-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_2?.home?.section_2?.card_section_two.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      {/* AI Icon Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />

                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.card_icon}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            {icons.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {icons.map((iconUrl, iconIndex) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() =>
                                        handleImageChange(iconUrl, index)
                                      }
                                    >
                                      <img
                                        src={iconUrl}
                                        alt="Card Icon"
                                        className="img-fluid"
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Icons Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI icons or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="card.card_title"
                          value={card.card_title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Sub Heading<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="card.card_sub_heading_top"
                          value={card.card_sub_heading_top}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">
                            Paragraph<small>(max 250 char)</small>
                          </label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleChange({
                                target: {
                                  name: 'card.card_paragraph',
                                  value: content,
                                },
                              }, index);
                            }}
                            contentType="website_description"
                            placeholder="Describe what you want in your card paragraph. Example: 'Write about this feature benefit'"
                            context="This is for a card description"
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="card.card_paragraph"
                          value={card.card_paragraph}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="add-section"></div>
                    </div>
                  )
                )}
              </div>
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={saveJsonData}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default IntroEditModal;
